const setitem = (a, b, c) => {
	a[b] = c;
};

export default setitem;
